import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
}
const sizeStyles = {
  sm: 'max-w-md',
  md: 'max-w-lg',
  lg: 'max-w-2xl',
  xl: 'max-w-4xl',
  full: 'max-w-6xl'
};
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  size = 'md'
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 overflow-y-auto print:static print:overflow-visible print:h-auto" data-id="element-1745">
      <div className="flex min-h-full items-center justify-center p-4 print:min-h-0 print:p-0 print:block print:h-auto" data-id="element-1746">
        {/* Backdrop */}
        <div className="fixed inset-0 bg-black/50 transition-opacity print:hidden" onClick={onClose} data-id="element-1747" />

        {/* Modal */}
        <div className={`
            relative w-full ${sizeStyles[size]}
            bg-white dark:bg-gray-800
            rounded-xl shadow-xl
            transform transition-all
            print:max-w-none print:shadow-none print:rounded-none print:transform-none print:h-auto
          `} data-id="element-1748">
          {/* Header - Hidden on print */}
          <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700 print:hidden" data-id="element-1749">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-1750">
              {title}
            </h2>
            <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors" data-id="element-1751">
              <XIcon className="w-5 h-5" data-id="element-1752" />
            </button>
          </div>

          {/* Content */}
          <div className="p-4 max-h-[calc(100vh-200px)] overflow-y-auto print:p-0 print:max-h-none print:overflow-visible print:h-auto" data-id="element-1753">
            {children}
          </div>
        </div>
      </div>
    </div>;
}